import { useRef, useState, useEffect } from "react";

export const useScrollAnimation = (threshold: number, onlyOnce: boolean,) => {
  const [isInViewport, setIsInViewport] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!ref.current) return; // 요소가 아직 준비되지 않은 경우 중단

    const callback = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 요소가 뷰포트에 나타났을 경우
          setIsInViewport(true);
        } else {
          // 요소가 뷰포트를 벗어난 경우
          if (onlyOnce) return;
          if (ref.current) {
            ref.current.style.transition = "all 0.5s";
            ref.current.style.opacity = "0";
          };
          setTimeout(() => {
            setIsInViewport(false);
          }, 500);
        }
      });
    };

    const options = { root: null, rootMargin: "0px", threshold: threshold };

    const observer = new IntersectionObserver(callback, options);
    observer.observe(ref.current); // 요소 관찰 시작

    return () => {
      observer.disconnect(); // 컴포넌트 언마운트 시 관찰 중단
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { isInViewport, ref };
};